import $ from 'jquery';

class SocialSharer {
  constructor() {
    this.shareButtons = $('.js-share-buttons');

    $(window).on('load', () => {
      this.init();
    });
  }

  setData() {
    this.data = {
      facebook: {
        shareUrl: 'https://www.facebook.com/sharer/sharer.php',
        params: {
          u: this.getValue('url'),
        },
      },
      linkedin: {
        shareUrl: 'https://www.linkedin.com/shareArticle',
        params: {
          url: this.getValue('url'),
          mini: true,
        },
      },
      twitter: {
        shareUrl: 'https://twitter.com/intent/tweet/',
        params: {
          text: this.getValue('title'),
          url: this.getValue('url'),
        },
      },
      pinterest: {
        shareUrl: 'https://www.pinterest.com/pin/create/button/',
        params: {
          url: this.getValue('url'),
          media: this.getValue('image'),
          description: this.getValue('desc'),
        },
      },
      email: {
        shareUrl: 'mailto:',
        params: {
          subject: this.getValue('subject'),
          body: `${this.getValue('title')}\r\n\r\n<a href="${this.getValue(
            'url',
          )}">View full article</a>\r\n\r\n ${this.getValue('url')}`,
        },
        isLink: true,
      },
    };
  }

  getValue(value) {
    return this.button.data(`sharer-${value}`);
  }

  init() {
    if (!this.shareButtons.length) {
      return;
    }

    // this.shareButtons.show();

    const buttons = this.shareButtons.find('[data-sharer]');

    if (buttons.length) {
      buttons.on('click', e => {
        e.preventDefault();

        this.button = $(e.currentTarget);
        const type = this.button.data('sharer');
        this.setData();
        const data = this.data[type];
        this.shareUrl = SocialSharer.createUrl(data);

        if (data.isLink) {
          window.location.href = this.shareUrl;
        } else {
          this.share();
        }
      });
    }
  }

  share() {
    if (this.shareUrl === null) {
      return;
    }

    const popup = {
      width: 600,
      height: 480,
      left: window.innerWidth / 2 - 600 / 2 + window.screenX,
      top: window.innerHeight / 2 - 480 / 2 + window.screenY,
    };

    const popupParams = `scrollbars=no, width=${popup.width}, height=${
      popup.height
    }, top=${popup.top}, left=${popup.left}`;
    const newWindow = window.open(this.shareUrl, '', popupParams);

    if (window.focus) {
      newWindow.focus();
    }
  }

  static createUrl(urlData) {
    if (typeof urlData === 'undefined') {
      return null;
    }

    const params = urlData.params || {};
    const keys = Object.keys(params);
    let str = keys.length > 0 ? '?' : '';

    for (let i = 0; i < keys.length; i += 1) {
      if (str !== '?') {
        str += '&';
      }

      if (params[keys[i]]) {
        str += `${keys[i]}=${encodeURIComponent(params[keys[i]])}`;
      }
    }

    return `${urlData.shareUrl}${str}`;
  }
}

export default new SocialSharer();



// WEBPACK FOOTER //
// ./src/scripts/modules/social-sharer.js